import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosService } from 'src/app/services/parametros.service';
import { SweetAlertService } from '../../../services/sweet-alert.service';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

@Component({
    selector: 'encuesta-microempresario',
    templateUrl: './encuesta.component.html',
    styleUrls: ['./encuesta.component.scss'],
    standalone: false
})
export class EncuestaComponent implements OnInit {
  preguntas: any[] = [];
  idSolicitud: string = '';
  respuestas: any[] = [];
  activarBoton: boolean = false;
  tamanoVideo: Number = null;
  tamanoVideoReal: Number = null;
  video: any;
  readonly archivoIcon = 'assets/img/perfil/icon-archivo-cargado.svg';
  videoFileName = '';
  videoSizeLabel = '';

  constructor(
    private _parametros: ParametrosService,
    private route: ActivatedRoute,
    private router: Router,
    private _sweetAlert: SweetAlertService,
    private _bancoldexService: BancoldexService,
    private _analyticsTag: AnalyticsTagService,
  ) {}

  ngOnInit() {
    this.getPreguntas();
    this.idSolicitud = this.route.snapshot.params.id;
    this.getParametroTamanoVideo();
    this.getDocumentoVideo();
    this.loadVideoEncuesta();
  }

  get hasVideo(): boolean {
    return !!this.video?.neoDocumentosSolicitudDTO?.urlArchivo;
  }

  get videoLabel(): string {
    const name = this.video?.nombre || 'Video de experiencia de usuario';
    return this.video?.obligatorio === false ? `${name} (Opcional)` : `${name} *`;
  }

  getPreguntas() {
    this._parametros.getPreguntasEncuesta().subscribe((response: any) => {
      this.preguntas = response;
      this.preguntas.forEach((pregunta) => {
        var array = null;
        if (pregunta.opcionesRespuesta != null) {
          array = pregunta.opcionesRespuesta
            .substring(1, pregunta.opcionesRespuesta.length - 1)
            .split(',');
          pregunta.opcionesRespuesta = array;
        }
      });
    });
  }

  guardarRespuesta(pregunta, rta) {
    this.borrarRespuestaAnterior(pregunta.idTipoPregunta);
    if (rta || rta!='') {
      if (pregunta.numerico == 1) {
        var respuestaNumerica = rta.split('.');
        this.respuestas.push({
          idTipoPregunta_NeoTipoPregunta: pregunta.idTipoPregunta,
          respuestaAbierta: null,
          respuestaNumerica: Number(respuestaNumerica[0]),
        });
      } else {
        this.respuestas.push({
          idTipoPregunta_NeoTipoPregunta: pregunta.idTipoPregunta,
          respuestaAbierta: rta,
          respuestaNumerica: null,
        });
      }
    }
    if (this.respuestas.length == this.preguntas.length) {
      this.activarBoton = true;
    } else {
      this.activarBoton = false;
    }
  }

  borrarRespuestaAnterior(idTipoPregunta) {
    this.respuestas.forEach((respuesta, index) => {
      if (respuesta.idTipoPregunta_NeoTipoPregunta == idTipoPregunta) {
        this.respuestas.splice(index, 1);
      }
    });
  }

  registrarRespuestas() {
    this._analyticsTag.trackCtaClick({
      ctaLabel: 'Registrar respuestas',
      ctaSection: 'encuesta',
      ctaComponent: 'encuesta',
      ctaElementId: 'btn-encuesta-registrar',
      hu: '8099',
    });
    const body: Respuestas = {
      idSolicitud: this.idSolicitud,
      respuestas: this.respuestas,
    };
    this._parametros.registrarRespuestas(body).subscribe((response: any) => {
      if (response.exitoso) {
        this.router.navigateByUrl('/microempresario/finalizarEncuesta');
      } else {
        this._sweetAlert.errorModal("Error!",true,'Se ha presentado un error');
      }
    });
  }

  trackVolver() {
    this._analyticsTag.trackCtaClick({
      ctaLabel: 'Volver',
      ctaSection: 'encuesta',
      ctaComponent: 'encuesta',
      ctaElementId: 'btn-encuesta-volver',
      hu: '8099',
    });
  }

  validateForm() {
    if (this.respuestas.length == this.preguntas.length) {
      this.registrarRespuestas();
    } else {
      this._sweetAlert.errorModal("Error!",true,'Responde las cuatro preguntas para continuar.');
    }
  }

  getParametroTamanoVideo() {
    var json = {
      idParametro: 'PAR-056',
      nombre: null,
      isParFuncional: false,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.tamanoVideoReal = Number(respuesta[0].valorParametro);
        this.tamanoVideo = Number(respuesta[0].valorParametro) * Number(1048576);
      },
      (error) => {}
    );
  }

  getDocumentoVideo() {
    this._parametros.getDocumentoVideoEncuesta().subscribe((data: any) => {
      this.video = data[0];
    });
  }

  loadVideoEncuesta(){
    this._bancoldexService.getVideoEncuestaByIdSolicitud(this.idSolicitud).subscribe((data: any) => {
      if (data.exitoso) {
        this.video.neoDocumentosSolicitudDTO = data.banner;
      } else {
        this.video.neoDocumentosSolicitudDTO = null;
      }
    });
  }

  saveVideo(event) {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const filename = file.name.split('.');
    const tipos = this.video;
    reader.onload = () => {
      const videoElement = document.createElement('video');
      videoElement.src = reader.result as string;
      videoElement.onloadedmetadata = () => {
        const videoDuration = videoElement.duration;
        if (videoDuration >= 120) {
          const minutes = Math.floor(videoDuration / 60);
          const seconds = Math.floor(videoDuration % 60);
          const mensaje =
            minutes != 0
              ? `El video que intentas cargar dura ${minutes} minutos y ${seconds} segundos. No puede ser mayor a 2 minutos.`
              : `El video que intentas cargar dura ${seconds} segundos. No puede ser mayor a 2 minutos.`;
          void this._sweetAlert.errorModal('Error!', true, mensaje);
          return;
        }
        if (this.tamanoVideo != null && file.size > Number(this.tamanoVideo)) {
          void this._sweetAlert.errorModal(
            'Error!',
            true,
            `El archivo pesa ${Math.trunc(file.size / Number(1048576))} MB supera el tamaño máximo permitido para contenido multimedia que es de ${this.tamanoVideoReal} MB`
          );
          return;
        }
        const permitidos = String(tipos?.tipoArchivoPermitido || '');
        if (
          permitidos &&
          (file.type === '' || permitidos.indexOf(file.type) < 0)
        ) {
          void this._sweetAlert.errorModal(
            'Error!',
            true,
            `Solo son permitidas las siguientes extensiones: ${tipos.extensionesValidas}`
          );
          return;
        }

        const json = {
          base64: reader.result.toString().split(',')[1],
          estado: 'POR APROBAR',
          extension: filename[filename.length - 1],
          idSolicitud_NeoSolicitudCredito: this.idSolicitud,
          nombreArchivo: this.video.nombreArchivoGuardado + '_' + this.idSolicitud,
          orden: null,
          tipoArchivo: 'Video',
          tipoBanner: 'VideoEncuesta',
          tipoContenido: file.type,
        };
        this._bancoldexService.addArchivoBanner(json).subscribe((data: any) => {
          if (data.exitoso) {
            this.videoFileName = file.name;
            this.videoSizeLabel = this.formatBytes(file.size);
            this.loadVideoEncuesta();
            this._sweetAlert.successModal(
              'Éxito.',
              false,
              '¡Tu video ha sido cargado y enviado correctamente! ¡Pronto podrá ser publicado en la plataforma!.'
            );
          } else {
            this._sweetAlert.errorModal(
              'Error!',
              true,
              !data.error ? 'No se pudo subir el archivo' : data.error
            );
          }
        });
      };
    };
  }

  deleteVideo(idBanner: number) {
    this._bancoldexService.deleteArchivoBanner(idBanner).subscribe((data: any) => {
      if (data.exitoso) {
        this.clearLocalVideo();
        this._sweetAlert.successModal('Video de experiencia de usuario eliminado.');
        this.getDocumentoVideo();
      } else {
        this._sweetAlert.errorModal("Error!",true,data.error);
      }
    });
  }

  private clearLocalVideo(): void {
    this.videoFileName = '';
    this.videoSizeLabel = '';
    if (this.video) {
      this.video.neoDocumentosSolicitudDTO = null;
    }
  }

  private formatBytes(bytes: number): string {
    if (!bytes || bytes < 0) {
      return '';
    }
    if (bytes < 1024) {
      return `${bytes} B`;
    }
    const kb = bytes / 1024;
    if (kb < 1024) {
      return `${kb.toFixed(1)} KB`;
    }
    return `${(kb / 1024).toFixed(1)} MB`;
  }
}

interface Respuestas {
  idSolicitud: string;
  respuestas: any[];
}
